import * as React from "react";
import { useState } from "react";
import styled from "@mui/material/styles/styled";
import { PanelPlanItem } from "./panelPlanItem";
import { LabSuggestionsClusterPanels } from "../useBuildPlanPanels";
import { PatientCaseChange } from "../usePatientCase";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

//region [[ Styles ]]

const PlanClusterView = styled("div")(({ theme }) => ({}));

const ClusterWrapper = styled("div")(
  ({ hideoutline }: { hideoutline: string }) => ({
    backgroundColor: "white",
    borderRadius: "5px",
    overflow: "hidden",

    boxShadow:
      hideoutline === "true" ? "unset" : "0px 1px 8px rgba(0, 0, 0, 0.12)",
    marginBottom: "12px",
  }),
);

const ClusterTitleContainer = styled("div")({
  textAlign: "left",
  display: "flex",
  marginLeft: "20px",

  alignItems: "center",
  justifyContent: "space-between",
});
const ClusterTitle = styled("div")({
  paddingTop: "20px",
  display: "flex",
  cursor: "pointer",
  paddingBottom: "20px",
});

const ClusterTitleLabel = styled("div")({});

const ClusterNumber = styled("div")({
  marginRight: "20px",
});

const ExpandIcon = styled(ExpandMoreIcon)(
  ({ expanded }: { expanded: string }) => ({
    transform: `rotate(${expanded === "true" ? "180" : "0"}deg)`,
    transition: "transform 0.3s ease-in",
    marginLeft: "5px",
    marginRight: "15px",
    cursor: "pointer",
  }),
);

//endregion [[ Styles ]]

//region [[ Props ]]

export interface PlanClusterProps {
  cluster: LabSuggestionsClusterPanels;
  index: number;
  isEmbedded?: boolean;
  onPlanItemChange: (change: PatientCaseChange) => void;
  loading: boolean;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const PlanCluster = ({ ...props }: PlanClusterProps) => {
  const [expanded, setExpanded] = useState(false);

  const onExpand = () => {
    setExpanded(!expanded);
  };

  return (
    <PlanClusterView key={props.index}>
      <ClusterWrapper hideoutline={props.isEmbedded ? "true" : "false"}>
        {props.cluster.title && (
          <ClusterTitleContainer onClick={onExpand}>
            <ClusterTitle>
              {props.cluster.title ? (
                <>
                  <ClusterNumber>{props.index + 1}</ClusterNumber>
                  <ClusterTitleLabel>{props.cluster.title}</ClusterTitleLabel>
                </>
              ) : (
                ""
              )}
            </ClusterTitle>

            <ExpandIcon expanded={expanded ? "true" : "false"} />
          </ClusterTitleContainer>
        )}

        {(expanded || props.cluster.items.length === 1) && (
          <div>
            {props.cluster.items.map((labPanel, index) => (
              <PanelPlanItem
                className={props.cluster.title ? "in-cluster" : "plan-item"}
                key={`${props.index} ${index}`}
                hideOutline={props.isEmbedded}
                index={
                  props.cluster.title
                    ? props.index + 1 + (index + 1) / 10
                    : props.index + 1
                }
                panel={labPanel.panel}
                suggestions={labPanel.suggestions}
                onChange={props.onPlanItemChange}
              />
            ))}
          </div>
        )}
      </ClusterWrapper>
    </PlanClusterView>
  );
};
